class MediaFade extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['image']
  }

  connectedCallback () {
    super.connectedCallback()

    if (!this.images || this.images.length < 2) return
    this.setupImageFade()
  }

  setupImageFade () {
    this.images.forEach((image, index) => {
      image.style.transition = `opacity ${this.duration}ms ease`
      image.style.opacity = 0

      if (index === 0) {
        image.style.opacity = 1
      }
    })

    setTimeout(() => {
      this.fadeImages()
    }, this.startDelay)
  }

  fadeImages () {
    let index = 0
    let nextIndex = 1
    setInterval(() => {
      this.images[index].style.opacity = 0
      this.images[nextIndex].style.opacity = 1

      index === this.images.length - 1 ? (index = 0) : index++
      nextIndex === this.images.length - 1 ? (nextIndex = 0) : nextIndex++
    }, this.delay)
  }

  get images () {
    return this.els.image.elements
  }

  get startDelay () {
    return parseInt(this.getAttribute('data-media-fade-start-delay')) || 500
  }

  get duration () {
    return parseInt(this.getAttribute('data-media-fade-duration')) || 500
  }

  get delay () {
    return parseInt(this.getAttribute('data-media-fade-delay')) || 8000
  }
}

if (!customElements.get('media-fade')) {
  customElements.define('media-fade', MediaFade)
}
